export { default } from "./FieldsConfig";
